// import logo from './logo.svg';
import React from 'react';
// import './App.css';
import { Switch } from "react-router-dom";
import { ProtectedRoute } from "./helpers/routes";
import './styles.less';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";


const queryClient = new QueryClient();

// import Dashboard from "./router/index"
const Dashboard = React.lazy(() => import("./router/index"));

function App() {
  return (
    <React.Suspense fallback={<div></div>}>
      <QueryClientProvider client={queryClient}>

        <Switch>
          <ProtectedRoute
            isAuthenticated={true}
            isLoading={false}
            path="/"
            component={Dashboard}
          />
        </Switch>
      </QueryClientProvider>

    </React.Suspense>
  );
}

export default App;
